import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CLAIM_STATUS_OPTIONS } from '@features/billing/constants/statusOptions';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { Button, Chip } from '@mui/material';
import type { ClaimReference } from '@store/generated/encounters';

interface ClaimStatusChipsProps {
  claims: ClaimReference[];
  encounterId?: string;
}

const READ_ONLY_STATUSES = ['submitted', 'acknowledged', 'accepted', 'rejected'];

export function getClaimWorkspacePath(claim: ClaimReference, encounterId?: string): string {
  if (encounterId) {
    return `/jotbill/encounter/${encounterId}?workspace=claim`;
  }

  const isReadOnly = READ_ONLY_STATUSES.includes(claim.status);
  return isReadOnly ? `/jotbill/claim/${claim.id}` : `/jotbill/claim/${claim.id}/edit`;
}

export const ClaimStatusChips: React.FC<ClaimStatusChipsProps> = ({ claims, encounterId }) => {
  const navigate = useNavigate();

  if (claims.length === 0) return null;

  return (
    <>
      {claims.map(claim => {
        const config = CLAIM_STATUS_OPTIONS.find(opt => opt.value === claim.status);
        const path = getClaimWorkspacePath(claim, encounterId);

        return (
          <Button
            key={claim.id}
            variant="outlined"
            startIcon={<VisibilityIcon />}
            onClick={() => navigate(path)}
            sx={{
              textTransform: 'none',
              fontWeight: 500,
              gap: 0.75,
            }}
          >
            View Claim
            <Chip
              label={config?.label || claim.status}
              size="small"
              color={config?.color || 'default'}
              sx={{
                fontSize: '0.7rem',
                height: 20,
                ml: 0.5,
              }}
            />
          </Button>
        );
      })}
    </>
  );
};
